import React, { FC } from "react";
import { DirectApply, Modal } from "@themuse/design-system";
import { JobCategory, JobLocation } from "@themuse/design-system/lib/components/DirectApply/DirectApplyTypes";
import { combinedSubscribe } from "utils/api";
import styles from "./DirectApplyModal.module.scss";

export interface DirectApplyModalProps {
    link: string;
    isDirectApplyOpen: boolean;
    setIsDirectApplyOpen: (x: boolean) => void;
    companyId: string;
    companyName: string;
    endpoint: string;
    atsJobId: string;
    jobId?: number;
    jobName: string;
    jobCategory: JobCategory | null;
    normalizedTitle: string;
    level: string;
    locations: JobLocation[];
    service: string;
}

// filler app
const noop = () => { };

// generate iframe and modal
export const DirectApplyModal: FC<DirectApplyModalProps> = ({
    link,
    isDirectApplyOpen,
    setIsDirectApplyOpen,
    companyId,
    companyName,
    endpoint,
    jobId,
    jobCategory,
    normalizedTitle,
    level,
    jobName,
    locations,
    atsJobId,
    service
}) => (
    <div title="Direct Apply Modal Wrapper">
        {/* Standard modal for mega */}
        {service === "mega" ? (
            <DirectApply {...{
                companyId,
                companyName,
                endpoint,
                isOpen: isDirectApplyOpen,
                jobId,
                jobCategory,
                normalizedTitle,
                level,
                jobName,
                link,
                locations,
                setIsOpen: setIsDirectApplyOpen,
                signUpCallBack: combinedSubscribe,
                atsJobId,
                service,
                showMoreJobsButton: true
            }}
            />
        ) : null}
        {/* Iframe modal for greenhouse */}
        {service === "iframe" ? (
            <Modal
                label="Direct Apply Modal."
                isOpen={isDirectApplyOpen}
                setIsOpen={setIsDirectApplyOpen}
                onOpen={noop}
                onClose={noop}
                timer={0}
                closeButtonClassName={styles.jobApplyModalCloseButton}
                containerClassName={styles.jobApplyModalContainer}
                contentClassName={styles.jobApplyModalContent}
            >
                <iframe
                    title="greenhouse apply frame"
                    src={`${link}#application`}
                    width="300"
                    height="500"
                    loading="lazy"
                    seamless={true}
                />
            </Modal>
        ) : null}
    </div>
);
DirectApplyModal.displayName = "DirectApplyModal";
